import { arrayToObject, versionsExecutionsToObject} from '../../../functions'
import * as actions from './actions'
import { createActionTypeReducer} from '../../../middleware'

const initialState = {
    items: {}
}

export const executionsReducer = createActionTypeReducer(initialState, {
    [actions.GET_EXECUTIONS_SUCCESS]: (state, action) => ({ ...state, items: arrayToObject(action.payload.items) }),
    [actions.GET_EXECUTIONS_FOR_VERSION_SUCCESS]: (state, action) => ({ ...versionsExecutionsToObject(state, action.payload.items) }),
})




// WEBPACK FOOTER //
// ./src/App/Admin/Executions/reducers.js